import { render, staticRenderFns } from "./ImportBlock.vue?vue&type=template&id=45735010&scoped=true"
import script from "./ImportBlock.vue?vue&type=script&lang=js"
export * from "./ImportBlock.vue?vue&type=script&lang=js"
import style0 from "./ImportBlock.vue?vue&type=style&index=0&id=45735010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45735010",
  null
  
)

export default component.exports